import DomainEntity from '@/models/DomainEntity'

export default class StrategyTools extends DomainEntity {
  static get collectionName() {
    return 'strategytools/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      buy: [],
      upgrade: {},
      sell: [],
    }
  }
}
